import { render, staticRenderFns } from "./conversation-assignee.vue?vue&type=template&id=4c25a977&"
import script from "./conversation-assignee.vue?vue&type=script&lang=js&"
export * from "./conversation-assignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports